module.exports = __webpack_public_path__ + "static/media/Grupo.ffbd9256.png";